import {Subject} from 'rxjs';
import {toUiMsg$} from './ui';
import type {TyMsg} from '@/types';

export interface UTingYun {
  type: 'tingyun-event';
  data: TyMsg;
}

export const ty$ = new Subject<TyMsg>();

ty$.subscribe((event) => toUiMsg$.next({type: 'tingyun-event', data: event}));
